
<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close @close="borrarInfo">
        <template #header>
          <h4 class="not-margin">
              <span>Cancelar factura </span>
          </h4>
        </template>


        <div class="con-form">
            <div class="con-content">
              <p>
                  La factura de <b> {{ row.concepto ? row.concepto : '' | uppercase }}</b>
              </p>
                  <p class="salto mb-1" v-if="row.factura && row.factura.uuid"><strong>UUID:</strong> <i class="fas fa-barcode"></i> {{ row.factura && row.factura.uuid ? row.factura.uuid : 'UUID No definido'}}</p>
                  <!-- <p class="salto mb-1"><strong> F.Pago:</strong> <i class="far fa-calendar-check"></i> {{ row.factura && row.factura.fecha_pago && row.factura.fecha_pago > '0000-00-00' ? row.factura.fecha_pago : 'No definido'}}</p> -->
                  <p class="salto mb-1"  v-if="row.factura && row.factura.fecha_factura"><strong>F.Factura:</strong> <i class="far fa-calendar"></i> {{ row.factura && row.factura.fecha_factura ? row.factura.fecha_factura : 'F. Factura No definido'}}</p>
                  
                  <label class="mt-2">Selecciona un motivo para cancelar factura</label>
                  <vs-select class="pl-0" placeholder="Seleccione un motivo" v-model="motivo">
                    <template #message-danger v-if="errorFields.includes('motivo')">
                      Requerido
                    </template>
                    <!--  v-if="JSON.parse(personaRol).roles[0].id == 1" NOTA: visualizar solo a nuestro rol -->
                    <vs-option label="01 - Comprobantes emitidos con errores con relación" value="01">
                      01 - Comprobantes emitidos con errores con relación
                    </vs-option>
                    <vs-option label="02 - Comprobantes emitidos con errores sin relación" value="02">
                      02 - Comprobantes emitidos con errores sin relación
                    </vs-option>
                    <vs-option label="03 - No se llevó a cabo la operación" value="03">
                      03 - No se llevó a cabo la operación
                    </vs-option>
                    <vs-option label="04 - Operación nominativa relacionada en una factura global" value="04">
                      04 - Operación nominativa relacionada en una factura global
                    </vs-option>
                  </vs-select>
            </div>
        </div>

        <template #footer>
          <div class="footer-dialog" style="display:flex; justify-content: space-between">  
            <vs-button style="width: 30%" block danger class="color-red" @click="borrarInfo()">
              Cancelar
            </vs-button>
            <vs-button style="width: 30%" :disabled="botonBloqueado" block success @click="getCancelarFactura()">
              Aceptar
            </vs-button>        
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import cobranza from '../../../../api/requests/cobranza-persona'
    export default {
        props:[
          'value',
          'row',
          'institucion',
          'personaRol'
        ],
        data:() => ({
            active: false,
            concepto: '',
            motivo: '',
            botonBloqueado: false,
            errorFields: []
        }),
        methods:{
          sanityForm () {
              this.errorFields = []
              if (!this.motivo) {
                  this.errorFields.push('motivo')
              }
              if (!this.errorFields.length){
                  return true
              } else {
                  return false
              }
          },
          async getCancelarFactura(){
              if(this.sanityForm() == true){
                const loading = this.$vs.loading()
                try { 
                  const params = {
                    uuid: this.row.factura.uuid,
                    motivo: this.motivo,
                    movimiento_id: this.row.movimiento_id
                  }
                  const response = await cobranza.postCancelar4(params)
                  // const response = await cobranza.getCancelFactura(this.institucion)
                  if(response.status === 200) {
                    this.borrarInfo()
                    this.$vs.notification({
                        progress: 'auto',                           
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: response.data.message
                    })
                    this.$emit('changeConcepto', this.row);
                    loading.close()
                  }
                } catch (error) {
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: error.response.data.message
                    })
                }
              }
          },
          borrarInfo(){
            this.motivo = ''
            this.active = false
          }
        },
        watch: {
            value (val) {
                this.active = val
            },
            active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
        }
    }
</script>
